import { css } from "styled-components";

type expandIconAnimationProps = {
  expanded: boolean;
};

export const expandIconAnimation = css<expandIconAnimationProps>`
  svg {
    transition: transform ease-in-out 0.2s;
    ${(props) =>
      props.expanded
        ? css`
            transform: rotate(180deg);
          `
        : css`
            transform: rotate(0deg);
          `}
  }
`;
